import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trash2, Download } from "lucide-react";
import { toast } from "sonner";
import { PageHeader, Card } from "@/components/admin/Primitives";

export default function Subscribers() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/subscribers").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Remove subscriber?")) return;
    await api.delete(`/admin/subscribers/${id}`);
    toast.success("Removed");
    load();
  };

  const exportCsv = () => {
    const rows = [["Email", "Name", "Phone", "Joined"]].concat(items.map((i) => [i.email, i.name || "", i.phone || "", new Date(i.created_at).toISOString()]));
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "subscribers.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-subscribers-page" className="text-white">
      <PageHeader
        title="Subscribers"
        subtitle="People who joined your newsletter — use them for bulk email or SMS."
        action={<button onClick={exportCsv} className="btn-outline" data-testid="export-subscribers"><Download className="h-4 w-4" /> Export CSV</button>}
      />
      <Card className="!p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="text-[10px] uppercase tracking-[0.15em] text-zinc-500 border-b border-[var(--pz-line)]">
                <th className="px-5 py-3 font-bold">Email</th>
                <th className="px-5 py-3 font-bold">Name</th>
                <th className="px-5 py-3 font-bold">Phone</th>
                <th className="px-5 py-3 font-bold">Joined</th>
                <th className="px-5 py-3 text-right font-bold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((row) => (
                <tr key={row.id} className="border-b border-[var(--pz-line)]/50 hover:bg-white/[0.03] text-zinc-200">
                  <td className="px-5 py-3 text-sm font-bold text-white">{row.email}</td>
                  <td className="px-5 py-3 text-sm">{row.name || "—"}</td>
                  <td className="px-5 py-3 text-sm">{row.phone || "—"}</td>
                  <td className="px-5 py-3 text-sm text-zinc-500">{new Date(row.created_at).toLocaleDateString()}</td>
                  <td className="px-5 py-3 text-right">
                    <button onClick={() => remove(row.id)} className="h-8 w-8 grid place-items-center rounded-full hover:bg-rose-500/10 text-rose-400 inline-grid"><Trash2 className="h-4 w-4" /></button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5} className="px-5 py-10 text-center text-zinc-500">No subscribers yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
